
function init(el) {

	// els
	const items = [...el.querySelectorAll('.js-job-item')]
	const locationFilter = el.querySelector('.js-job-filter--location')
	const typeFilter = el.querySelector('.js-job-filter--type')
	const noResults = el.querySelector('.js-jobs-no-results')

	// settings
	const useUrlParams = el.getAttribute('data-url-params') !== null
	const maxItems = el.getAttribute('data-limit') || Infinity

	// values
	let selectedLocation = locationFilter.value, 
		selectedType = typeFilter.value

	if (useUrlParams) {
		const uri = new URL(window.location)
		selectedLocation = uri.searchParams.get('location')
		selectedType = uri.searchParams.get('type')
	}

	const jobs = items.map(el => {
		const locations = arrayToMap((el.getAttribute('data-job-location') || '').split('|').filter(Boolean))
		const types = arrayToMap((el.getAttribute('data-job-type') || '').split('|').filter(Boolean))
		return {
			locations, types, el
		}
	})

	function update() {

		if (useUrlParams) {
			const uri = new URL(window.location)
			if (selectedLocation) {
				uri.searchParams.set('location', selectedLocation)
			} else {
				uri.searchParams.delete('location')
			}

			if (selectedType) {
				uri.searchParams.set('type', selectedType || '')
			} else {
				uri.searchParams.delete('type')
			}

			window.history.replaceState(null , '', uri.toString())
		}

		noResults.style.display = 'none'
		
		const matched = jobs.filter(job => {
			const requiredMatches = [
				selectedLocation, 
				selectedType
			].filter(Boolean).length
			// no required matches, all jobs match filters
			if (!requiredMatches) return true
			let matches = 0
			if (job.locations[selectedLocation]) matches++
			if (job.types[selectedType]) matches++
			if (matches >= requiredMatches) return true
		})

		const toDisplay = matched.slice(0, maxItems)
		
		jobs.map(job => job.el.style.display = 'none')
		toDisplay.map(job => job.el.style.display = '')
		
		if (!toDisplay.length) noResults.style.display = 'block'
	}


	locationFilter.addEventListener('change', event => {
		selectedLocation = event.currentTarget.value
		update()
	})

	typeFilter.addEventListener('change', event => {
		selectedType = event.currentTarget.value
		update()
	})

	update()
}


function arrayToMap(array, value = true) {
	return Object.fromEntries(array.map(k => [k, value]))
}


export default function() {
	const els = [...document.querySelectorAll('.js-job-module')]
	els.map(init)
}